import React from 'react';
import { TickContainer, TickPath } from './styles';

const Tick = () => (
  <TickContainer data-testid="saved">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0  55.626 42.139">
      <TickPath d="M49.889,2.852l-30.274,30.6L5.748,19.649l-2.93,2.994,16.8,16.667,33.2-33.463Z" />
    </svg>
  </TickContainer>
);

export default Tick;
